import { z } from 'zod';

import {
  Context,
  InteractionType,
  Strategy,
  Timing,
  Engine,
  Trigger,
  ThresholdExpression,
} from '../../enums';

export const MetricCreateRequest = z.object({
  name: z.string().min(1),
  description: z.string().optional(),
  context: z.nativeEnum(Context),
  strategy: z.nativeEnum(Strategy),
  timing: z.nativeEnum(Timing),
  interactionType: z.nativeEnum(InteractionType),
  selectors: z.array(
    z.object({
      description: z.string(),
      path: z.string(),
      values: z.array(z.string()),
    }),
  ),
  preprocessing: z.array(z.string()).optional(),
  resourceType: z.array(z.string()),
  tags: z.array(z.string()),
  environments: z.array(z.string()),
  cronExpression: z.string().optional(),
  externalUrl: z.string().optional(),
  engine: z.nativeEnum(Engine),
  thresholds: z.object({
    expression: z.nativeEnum(ThresholdExpression),
    range: z
      .array(
        z.object({
          value: z.number(),
          labelColor: z.string(),
          label: z.string(),
        }),
      )
      .optional(),
  }),
  domain: z.object({
    lowerBound: z.number(),
    upperBound: z.number(),
  }),
  additionalMetadata: z.string(),
  trigger: z.nativeEnum(Trigger),
});

export type MetricCreate = z.infer<typeof MetricCreateRequest>;
